import { Component, OnInit, Input, Output, EventEmitter, forwardRef } from '@angular/core';
import { 
    IonLabel, IonNote
} from '@ionic/angular/standalone';
import { TranslatePipe } from '@ngx-translate/core';

import { MarvItemComponent, MarvTagComponent, MarvCircleComponent, MarvButtonComponent } from '@marv/components';
import { MarvColor, MarvColorGreen, MarvColorOrange, MarvColorRed } from '@marv/types';
import { OperationItem, OperationLogo, OperationLogoComponent, OperationDaysRemainingComponent } from '@app/components';
import { LoggedUserService, MissionTypeService } from '@app/services';
import { EpochToStringPipe } from '@app/pipes';

@Component({
    selector: 'app-operation-item',
    templateUrl: './item.component.html',
    styleUrls: ['./item.component.scss'],
    imports: [
        IonLabel, IonNote, TranslatePipe, forwardRef(() => MarvItemComponent), forwardRef(() => MarvTagComponent), 
        forwardRef(() => MarvCircleComponent), forwardRef(() => MarvButtonComponent), 
        EpochToStringPipe, forwardRef(() => OperationLogoComponent), forwardRef(() => OperationDaysRemainingComponent)
    ]
})
export class OperationItemComponent  implements OnInit {

    @Input({alias : 'operation', required : true}) operation: OperationItem;
    @Input({alias : 'displayRemainingDays', required : false}) displayRemainingDays: boolean = false;
    @Input({alias : 'displayQuota', required : false}) displayQuota: boolean = false;
    @Input({alias : 'displayNbMissionsPlanned', required : false}) displayNbMissionsPlanned: boolean = false;
    @Input({alias : 'displayBtnAddIntervention', required : false}) displayBtnAddIntervention: boolean = false;
    @Input({alias : 'disabledBtnAddIntervention', required : false}) disabledBtnAddIntervention: boolean = false;
    @Input({alias : 'displayBtnRemoveOperation', required : false}) displayBtnRemoveOperation: boolean = false;
    @Input({alias : 'disabledBtnRemoveOperation', required : false}) disabledBtnRemoveOperation: boolean = false;
    @Input({alias : 'enableSelectOperation', required : false}) enableSelectOperation: boolean = true;
    @Output() onSelectOperation = new EventEmitter<OperationItem>();
    @Output() onAddIntervention = new EventEmitter<OperationItem>();
    @Output() onRemoveOperation = new EventEmitter<OperationItem>();
    
    isLoggedUserAllowedToPlan: boolean = false;
    
    constructor(        
        private loggedUserService: LoggedUserService,
        public missionTypeService: MissionTypeService
    ) { }

    ngOnInit() {
        this.isLoggedUserAllowedToPlan = (this.loggedUserService.loggedUser?.customerPlanningAllowed === true);
    }
    
    getOperationLogo(): OperationLogo{
        return new OperationLogo(this.operation.name, this.operation.logo);
    }

    selectOperation(){
        if(this.enableSelectOperation){
            this.onSelectOperation.emit(this.operation);
        }
    }
    
    getColorRemainingDays(remainingDays: number): MarvColor{
        let color: MarvColor = MarvColorGreen;
        if(remainingDays <= 5){
            color = MarvColorRed;
        } 
        else if(remainingDays <= 15){
            color = MarvColorOrange;
        } 
        return color;
    }
    
    addIntervention($event: any){
        $event.stopPropagation();
        if(!this.disabledBtnAddIntervention){
            this.onAddIntervention.emit(this.operation);
        }
    }
    
    removeOperation($event: any){
        $event.stopPropagation();
        if(!this.disabledBtnRemoveOperation){
            this.onRemoveOperation.emit(this.operation);
        }
    }
    
    roundQuota(quota: number): number {
        return Math.floor(quota);
    }
}
